import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import de from '@locales/de/translation.json';
import es from '@locales/es/translation.json';
import fr from '@locales/fr/translation.json';
import it from '@locales/it/translation.json';
import pt from '@locales/pt-BR/translation.json';
import ru from '@locales/ru/translation.json';
import tr from '@locales/tr/translation.json';
import uk from '@locales/uk/translation.json';
import zh from '@locales/zh/translation.json';
import en from '@locales/en/translation.json';
import ar from '@locales/ar/translation.json';
import hi from '@locales/hi/translation.json';
import ko from '@locales/ko/translation.json';
import pl from '@locales/pl/translation.json';
import ja from '@locales/jp/translation.json';
import th from '@locales/th/translation.json';
import vi from '@locales/vi/translation.json';
import { normalizeI18nLanguage, SUPPORTED_I18N_LANGUAGE_CODES } from '@utils/languageContract';

const resources = {
  en: { translation: en },
  de: { translation: de },
  es: { translation: es },
  fr: { translation: fr },
  it: { translation: it },
  pt: { translation: pt },
  ru: { translation: ru },
  tr: { translation: tr },
  uk: { translation: uk },
  zh: { translation: zh },
  ar: { translation: ar },
  hi: { translation: hi },
  ko: { translation: ko },
  pl: { translation: pl },
  ja: { translation: ja },
  'ja-JP': { translation: ja },
  jp: { translation: ja },
  th: { translation: th },
  vi: { translation: vi },
  'pt-BR': { translation: pt },
  'pt-PT': { translation: pt },
  'zh-CN': { translation: zh },
  'zh-Hans': { translation: zh },
  'zh-SG': { translation: zh },
  'zh-TW': { translation: zh },
  'zh-Hant': { translation: zh },
  'zh-HK': { translation: zh },
  'zh-MO': { translation: zh },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: SUPPORTED_I18N_LANGUAGE_CODES,
    fallbackLng: 'en',
    detection: {
      convertDetectedLanguage: normalizeI18nLanguage,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
